var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.019,
    height: 20.092,
    viewBox: "0 0 21.019 20.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.51 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M19.971,19.041a.586.586,0,0,0-.473-.4l-6.2-.9-2.773-5.618a.586.586,0,0,0-1.051,0L6.7,17.741l-6.2.9a.586.586,0,0,0-.325,1l4.486,4.373L3.6,30.189a.586.586,0,0,0,.85.618L10,27.892l5.545,2.915a.586.586,0,0,0,.85-.618l-1.059-6.175,4.487-4.373A.586.586,0,0,0,19.971,19.041Z",
    transform: "translate(0 -11.796)",
    fill: "currentColor",
    stroke: "#324562",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/Start.56bf9495bde4c53af62c3cccc2aa9081.svg";
export { ForwardRef as ReactComponent };